import React from "react";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";
import Subtopic from '../../../components/Subtopic/Subtopic';
import ListUnordered from '../../../components/ListUnordered/ListUnordered';

const SigaPage = () => {
	return (
		<>
			<TopicFrame topicType="signalTheorie" entryNumber={0}>
				<Subtopic id="SinCos" Title="ausgewählte Befehle">
					<ListUnordered>
						<a href="https://www.wolframalpha.com/input?i=sin%282*pi*f*t%29+where+f%3D1">sin(2*pi*f*t)
							where f=1</a>
						<a
							href="https://www.wolframalpha.com/input?i=plot+sin+t+%2B+cos+%28sqrt%283%29t%29+handwritten+style">plot
							sin t + cos (sqrt(3)t) handwritten style</a>
						<a href="https://www.wolframalpha.com/input?i=sinc%28t%29">sinc(t)</a>
						<a href="https://www.wolframalpha.com/input?i=UnitBox%28t%29">UnitBox(t)</a>
						<a href="https://www.wolframalpha.com/input?i=unitTriangle%28t%29">unitTriangle(t)</a>
						<a href="https://www.wolframalpha.com/input?i=+convolve%28+piecewise%5B%7B%7B1%2C0%3C%3Dt%3C%3D1%7D%7D%2C+0%5D%2C+sin%28pi*t%29+%29">{"convolve( piecewise[{{1,0<=t<=1}}, 0], sin(pi*t) )"}</a>
					</ListUnordered>
				</Subtopic>
			</TopicFrame>
		</>
	);
};

export default SigaPage;
